import { firestore } from "../firebase";

import {
  collection,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

const siteRef = collection(firestore, "sites");
class SiteDataService {
  addSites = (newSite) => {
    return addDoc(siteRef, newSite);
  };

  updateSite = (id, updatedSite) => {
    const siteDoc = doc(firestore, "sites", id);
    return updateDoc(siteDoc, updatedSite);
  };

  deleteSite = (id) => {
    const siteDoc = doc(firestore, "sites", id);
    return deleteDoc(siteDoc);
  };

  getAllSites = () => {
    return getDocs(siteRef);
  };

  getSite = (id) => {
    const siteDoc = doc(firestore, "sites", id);
    return getDoc(siteDoc);
  };
}

export default new SiteDataService();
